import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface EmailQuotaCardProps {
  remaining?: number;
  isLoading?: boolean;
}

const EmailQuotaCard: React.FC<EmailQuotaCardProps> = ({
  remaining,
  isLoading = false,
}) => {

  console.log('EmailQuotaCard - remaining:', remaining, 'type:', typeof remaining);

  if (isLoading) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-2 mb-2 inline-block">
        <Skeleton height={20} width={150} className="mb-1" />
        <Skeleton height={24} width={80} />
      </div>
    );
  }

  if (remaining === undefined || remaining === null) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-2 mb-2 inline-block">
        <h2 className="text-base font-semibold text-gray-900 mb-1 text-center">Email Blast Quota</h2>
        <p className="text-sm text-gray-500 text-center">Unable to load</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-150 p-2 mb-2 inline-block">
      <h2 className="text-base font-semibold text-gray-900 mb-1 text-center">Email Blast Quota</h2>
      <p className="text-xs text-gray-500 text-center mb-1">Remaining quota</p>
      <div className="flex items-center justify-center">
        <p className="text-xl font-bold text-gray-900">{remaining.toLocaleString()}</p>
      </div>
    </div>
  );
};

export default EmailQuotaCard;
